export default "__VITE_ASSET__BGeiG5PL__"